<template>
	<glass-card class="terms-of-use-container">
		<div class="container py-5">
			<h1>Terms of Use</h1>
			<p>Last updated: 3/12/2025</p>

			<h2>Agreement to Terms</h2>
			<p>
				By accessing or using our service, you agree that you have read,
				understood, and agreed to be bound by these Terms and our
				<a href="/privacy-policy">Privacy Policy</a>.
			</p>

			<h2>Intellectual Property Rights</h2>
			<p>
				Except for the content you own, under these Terms, Grub Vision and/or
				its licensors own all the intellectual property rights and materials
				contained in this service.
			</p>

			<h2>Restrictions</h2>
			<p>You are specifically restricted from the following:</p>
			<ul>
				<li>Publishing any service material in any other media.</li>
				<li>
					Selling, sublicensing, and/or otherwise commercializing any service
					material.
				</li>
				<li>Publicly performing and/or showing any service material.</li>
				<li>
					Using this service in any way that is damaging to this service or in
					any way that impacts user access to this service.
				</li>
			</ul>

			<h2>Your Content</h2>
			<p>
				"Your Content" shall mean any audio, video, text, images, or other
				material you choose to display on this service. By displaying Your
				Content, you grant Grub Vision a non-exclusive, worldwide, irrevocable
				license to use, reproduce, adapt, publish, translate, and distribute it
				in any and all media.
			</p>

			<h2>Third-Party Services</h2>
			<p>
				Our service uses third-party services to recognize and analyze food
				items in images and to process health information for AI-driven
				features. By using our service, you grant us permission to process your
				data with these third-party services for the purpose of providing
				nutritional estimates and other AI-driven features.
			</p>

			<h2>Artificial Intelligence</h2>
			<p>
				Grub Vision uses artificial intelligence (AI) to provide various
				features and services, such as food recognition and nutritional
				estimates. To power these features, we may process your data, including
				images and health information, using AI models. These AI models may be
				developed by us or provided by third-party services.
			</p>
			<p>By using our service, you acknowledge and agree that:</p>
			<ul>
				<li>
					Your data may be used to train or improve our AI models or those of
					our third-party service providers.
				</li>
				<li>
					The AI-based features are provided for informational purposes only and
					may not be entirely accurate.
				</li>
				<li>
					You are responsible for any decisions you make based on the
					information provided by our AI features.
				</li>
			</ul>
			<p>
				We strive to ensure that our AI models are fair and transparent, and we
				take steps to mitigate any biases or inaccuracies. However, no AI system
				is perfect, and we cannot guarantee the accuracy or completeness of the
				information provided by our AI features.
			</p>
			<p>
				If you have any concerns or questions about our use of AI, please
				contact us at sdeutsch@digitalfuturelabs.com.
			</p>

			<h2>Accuracy of Information</h2>
			<p>
				The nutritional information provided by Grub Vision is based on
				estimations made by artificial intelligence and should not be considered
				medical or dietary advice. While we strive for accuracy, Grub Vision
				does not guarantee that the information provided by the AI is
				error-free, and we are not responsible for any decisions made based on
				this information.
			</p>

			<h2>No Warranties</h2>
			<p>
				This service is provided “as is,” with all faults, and Grub Vision
				expresses no representations or warranties of any kind related to this
				service or the materials contained on this service.
			</p>

			<h2>Limitation of Liability</h2>
			<p>
				In no event shall Grub Vision, nor any of its officers, directors, and
				employees, be held liable for anything arising out of or in any way
				connected with your use of this service.
			</p>

			<h2>Indemnification</h2>
			<p>
				You hereby indemnify to the fullest extent Grub Vision from and against
				any and/or all liabilities, costs, demands, causes of action, damages,
				and expenses arising in any way related to your breach of any of the
				provisions of these Terms.
			</p>

			<h2>Severability</h2>
			<p>
				If any provision of these Terms is found to be invalid under any
				applicable law, such provisions shall be deleted without affecting the
				remaining provisions herein.
			</p>

			<h2>Variation of Terms</h2>
			<p>
				Grub Vision is permitted to revise these Terms at any time as it sees
				fit, and by using this service you are expected to review these Terms on
				a regular basis.
			</p>

			<h2>Assignment</h2>
			<p>
				The Grub Vision is allowed to assign, transfer, and subcontract its
				rights and/or obligations under these Terms without any notification.
				However, you are not allowed to assign, transfer, or subcontract any of
				your rights and/or obligations under these Terms.
			</p>

			<h2>Entire Agreement</h2>
			<p>
				These Terms constitute the entire agreement between Grub Vision and you
				in relation to your use of this service, and supersede all prior
				agreements and understandings.
			</p>

			<h2>Governing Law & Jurisdiction</h2>
			<p>
				These Terms will be governed by and interpreted in accordance with the
				laws of the state and/or country in which Grub Vision is based, and you
				submit to the non-exclusive jurisdiction of the state and federal courts
				located in for the resolution of any disputes.
			</p>

			<h2>Contact Information</h2>
			<p>
				If you have any inquiries or questions about these Terms, please contact
				us at sdeutsch@digitalfuturelabs.com.
			</p>
		</div>
	</glass-card>
</template>

<script setup>
	import GlassCard from "@/components/GlassCard.vue"
</script>

<style lang="less" scoped>
	.terms-of-use-container {
		h1,
		h2 {
			color: #ff6400 !important;
		}
		p,
		li {
			color: #ff6400;
		}
		ul {
			list-style-type: none;
			padding-left: 0;
		}
		li {
			padding-left: 1em;
			text-indent: -1em;
		}
	}
</style>
